import React from 'react';

const calculateOffset = (offset) => {
  if (offset > 3.5) offset = (offset - 3.5) / 1.5 + 3.5;
  return (5 - offset) * 100 - 30;
};

const ValueIndicator = ({ value }) => {
  const pixelOffset = calculateOffset(value);
  return (
    <polygon 
      points={createOffsetStar(pixelOffset - 16)} 
      fill="white" 
      stroke="black" 
    />
  );
};

const starBasePoints = [
  { x: 22.5, y: 35.25},
  { x: 8.68704657, y: 42.5118994 },
  { x: 11.3250859, y: 27.1309497 },
  { x: 0.150171867, y: 16.2381006 },
  { x: 15.5935233, y: 13.9940503 },
  { x: 22.5, y: 0},
  { x: 29.4064767, y: 13.9940503 },
  { x: 44.8498281, y: 16.2381006 },
  { x: 33.6749141, y: 27.1309497 },
  { x: 36.3129534, y: 42.5118994 }
];

const createOffsetStar = (offset) => 
  starBasePoints.reduce(
    (pre, next) => pre + ' ' + (next.x + 227.5) + ' ' + (next.y + offset), 
    ''
  );

const BrainModel = ({ value }) => {
  value = value ?? 5;

  return (
    <svg viewBox="0 0 500 500">
      <polygon points="10,30 490,30 440,130 60,130" style={{"fill":"deepskyblue", "stroke":"black","stroke-width":1}} />
      <text x="25" y="50">Cortical</text>
      <text x="475" y="50" text-anchor="end">Calm / Alert</text>
      <polygon points="60,130 440,130 390,230 110,230" style={{"fill":"greenyellow", "stroke":"black","stroke-width":1}} />
      <text x="75" y="150">Limbic</text>
      <text x="425" y="150" text-anchor="end">Alarm</text>
      <polygon points="110,230 390,230 340,330 160,330" style={{"fill":"gold", "stroke":"black","stroke-width":1}} />
      <text x="125" y="250">Midbrain</text>
      <text x="375" y="250" text-anchor="end">Fear</text>
      <polygon points="160,330 340,330 290,430 210,430" style={{"fill":"pink", "stroke":"black","stroke-width":1}} />
      <text x="175" y="350">Brainstem</text>
      <text x="325" y="350" text-anchor="end">Terror</text>
      <ValueIndicator value={value} />
    </svg>
  );
}

export default BrainModel;